import axios from 'axios';
import PostInterface from '../interfaces/PostInterface.ts';

class ServerAccessor {
    static ENDPOINT = 'https://api.promonsa.net';

    async getPost(postId: string): Promise<PostInterface> {
        const url = ServerAccessor.ENDPOINT + `/post/${postId}`;
        const res = await axios.get(url);
        if (res.status === 200) {
            return res.data;
        } else {
            throw new Error('Failed to fetch all posts');
        }
    }

    async getAllPosts(): Promise<PostInterface[]> {
        const url = ServerAccessor.ENDPOINT + "/post";
        const res = await axios.get(url);
        if (res.status === 200) {
            return res.data;
        } else {
            throw new Error('Failed to fetch all posts');
        }
    }

    async deletePost(postId: string, accessToken: string | null): Promise<undefined> {
        const url = ServerAccessor.ENDPOINT + `/post/${postId}`;
        const res = await axios.delete(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (res.status === 200) {
            return res.data;
        } else {
            throw new Error('Failed to delete post');
        }
    }

    async uploadNewPost(post: PostInterface, accessToken: string | null) {
        const url = ServerAccessor.ENDPOINT + "/post";
        const res = await axios.post(url, JSON.stringify(post), {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            },
        });
        if (res.status === 200) {
            return true;
        } else {
            throw new Error('Failed to save post');
        }
    }

    async updateExistingPost(post: PostInterface, accessToken: string | null) {
        const url = ServerAccessor.ENDPOINT + `/post/${post.postId}`;
        const res = await axios.put(url, JSON.stringify(post), {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            },
        });
        if (res.status === 200) {
            return true;
        } else {
            throw new Error('Failed to save post');
        }
    }

    async login(password: string) {
        const url = ServerAccessor.ENDPOINT + "/auth/login";
        const res = await axios.post(url, {
            password: password
        }, {
            withCredentials: true
        });
        if (res.status === 200) {
            return res.data;
        } else {
            return null;
        }
    }

    async refreshAuthToken() {
        const url = ServerAccessor.ENDPOINT + "/auth/refresh";
        const res = await axios.post(url, {}, { withCredentials: true });
        if (res.status === 200) {
            return res.data;
        } else {
            return null;
        }
    }

    async presignImage(
        postId: string,
        imageId: string,
        extension: string,
        contentType: string,
        accessToken: string | null): Promise<{ uploadUrl: string, publicUrl: string; }> {
        const url = ServerAccessor.ENDPOINT + "/post/presign";
        const res = await axios.post(url, {
            postId: postId,
            imageId: imageId,
            extension: extension,
            contentType: contentType
        }, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        if (res.status === 200) {
            return res.data;
        } else {
            throw new Error("error while getting presign url");
        }
    }
}

export const serverAccessor = new ServerAccessor();